import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { saveEquipmentPreferences } from '../../../store/ducks/user';
import SettingsContainer from '../../../components/settings-container';
import MultiSelect from '../../../components/multi-select';

const selectOptions = [
  {
    optionText: 'None',
    optionValue: 'none'
  },
  {
    optionText: 'Plyometric box',
    optionValue: 'box'
  },
  {
    optionText: 'Dumbbell',
    optionValue: 'dumbbells'
  },
  {
    optionText: 'Exercise ball',
    optionValue: 'exerciseball'
  },
  {
    optionText: 'Pull-up bar',
    optionValue: 'pullupbar'
  },
  {
    optionText: 'Kettlebell',
    optionValue: 'kettlebell'
  },
  {
    optionText: 'Treadmill',
    optionValue: 'treadmill'
  },
  {
    optionText: 'Incline trainer',
    optionValue: 'inclinetrainer'
  },
  {
    optionText: 'Cable machine',
    optionValue: 'cablemachine'
  }
];

export class PureEquipmentPreferences extends Component {
  constructor(props) {
    super(props);

    this.state = {
      equipment: props.initialValue
    };
  }

  save = async () => {
    try {
      let equipment;
      if (this.state.equipment.length === 1 && this.state.equipment[0] === 'none') {
        equipment = [];
      } else {
        equipment = this.state.equipment;
      }
      await this.props.saveEquipmentPreferences(equipment);
    } catch (e) {
      /* do nothing */
    }
  }

  getActiveOptions = () => {
    const activeOptions = [];
    this.state.equipment.forEach((item) => {
      activeOptions.push(selectOptions.findIndex((el) => {
        return el.optionValue === item;
      }));
    });

    return activeOptions;
  }

  setEquipment = (activeOptions) => {
    const equipment = [];

    if (activeOptions.indexOf(0) !== -1 && this.state.equipment.indexOf('none') === -1) {
      equipment.push('none');
    } else {
      activeOptions.forEach((index) => {
        if (selectOptions[index].optionValue !== 'none') {
          equipment.push(selectOptions[index].optionValue);
        }
      });
    }

    this.setState({ equipment });
  }

  render() {
    return (
      <SettingsContainer
        save={ this.save }
        className="settings-equipment-page"
        pageTitle="What exercise equipment do you have access to?"
        subtitle
        seeMoreIncluded
        isValid={ Boolean(this.state.equipment.length) }
      >
        <MultiSelect
          selectOptions={ selectOptions }
          initialValue={ this.getActiveOptions() }
          setActiveOptions={ this.setEquipment }
          seeMoreButtonOptions={ 6 }
        />
      </SettingsContainer>
    );
  }
}

PureEquipmentPreferences.propTypes = {
  initialValue: PropTypes.array.isRequired,
  saveEquipmentPreferences: PropTypes.func.isRequired
};

PureEquipmentPreferences.defaultProps = {
  initialValue: []
};

export default connect(
  state => ({
    initialValue: state.user.equipment
  }),
  dispatch => ({
    saveEquipmentPreferences: equipment => dispatch(saveEquipmentPreferences(equipment))
  }),
  null,
  { withRef: true }
)(PureEquipmentPreferences);
